// Item 4 — the applied filter state (global bar, slicers, filter widgets) survives a reload,
// reopening the dashboard and moving between builder preview and the published viewer.
// It is per-user, per-dashboard and client-side only, so saved dashboards and other viewers
// are never changed by one person's selections.

const KEY = (id) => `eip_filterstate_${id}`;
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;

const empty = (o) => !o || !Object.keys(o).length;

export function loadFilterState(dashboardId) {
  if (!dashboardId) return null;
  try {
    const raw = localStorage.getItem(KEY(dashboardId));
    if (!raw) return null;
    const st = JSON.parse(raw);
    if (!st || (st.t && Date.now() - st.t > MAX_AGE_MS)) {
      localStorage.removeItem(KEY(dashboardId));
      return null;
    }
    return st;
  } catch { return null; }
}

export function hasFilterState(dashboardId) {
  const st = loadFilterState(dashboardId);
  return !!st && (!empty(st.gf) || !empty(st.sl) || !empty(st.fw));
}

export function saveFilterState(dashboardId, { gf, sl, fw }) {
  if (!dashboardId) return;
  try {
    if (empty(gf) && empty(sl) && empty(fw)) localStorage.removeItem(KEY(dashboardId));
    else localStorage.setItem(KEY(dashboardId), JSON.stringify({ gf, sl, fw, t: Date.now() }));
  } catch { /* storage full or disabled — filters simply won't persist */ }
}
